import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ocr-1.genxinc.ai';

// 認証トークンを取得する関数
const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

// API用のaxiosインスタンスを作成
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// リクエストインターセプターで認証トークンを追加
apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * 参照データ管理API
 */
export const referenceDataApi = {
  /**
   * プロジェクトの参照データ一覧を取得
   * @param {string} projectId - プロジェクトID
   * @returns {Promise} 参照データ一覧
   */
  getReferenceDataList: (projectId) => {
    return apiClient.get(`/api/projects/${projectId}/reference-data`);
  },

  /**
   * 参照データを作成
   * @param {string} projectId - プロジェクトID
   * @param {FormData} formData - アップロードするファイルデータ
   * @returns {Promise} 作成された参照データ
   */
  createReferenceData: (projectId, formData) => {
    return apiClient.post(`/api/projects/${projectId}/reference-data`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * 参照データの詳細を取得
   * @param {string} projectId - プロジェクトID
   * @param {string} referenceDataId - 参照データID
   * @returns {Promise} 参照データの詳細
   */
  getReferenceData: (projectId, referenceDataId) => {
    return apiClient.get(`/api/projects/${projectId}/reference-data/${referenceDataId}`);
  },

  /**
   * 参照データを更新
   * @param {string} projectId - プロジェクトID
   * @param {string} referenceDataId - 参照データID
   * @param {Object} data - 更新データ
   * @returns {Promise} 更新された参照データ
   */
  updateReferenceData: (projectId, referenceDataId, data) => {
    return apiClient.put(`/api/projects/${projectId}/reference-data/${referenceDataId}`, data);
  },

  /**
   * 参照データを削除
   * @param {string} projectId - プロジェクトID
   * @param {string} referenceDataId - 参照データID
   * @returns {Promise} 削除結果
   */
  deleteReferenceData: (projectId, referenceDataId) => {
    return apiClient.delete(`/api/projects/${projectId}/reference-data/${referenceDataId}`);
  },

  /**
   * 参照データの内容をJSON形式で取得
   * @param {string} projectId - プロジェクトID
   * @param {string} referenceDataId - 参照データID
   * @returns {Promise} JSON形式の参照データ
   */
  getReferenceDataAsJson: (projectId, referenceDataId) => {
    return apiClient.get(`/api/projects/${projectId}/reference-data/${referenceDataId}/json`);
  },
};

export default referenceDataApi;